module.exports = __webpack_public_path__ + "static/media/color-sharp.d6409477.png";